import React, { useState } from "react";
import Layout from "./common/Layout";
import "../css/StoreManage.scss";

const StoreManage = () => {
  const [activeTab, setActiveTab] = useState("店铺集管");
  const [showModal, setShowModal] = useState(false);

  // 处理未授权访问
  const handleUnauthorized = () => {
    setShowModal(true);
  };

  // 关闭模态框
  const handleCloseModal = () => {
    setShowModal(false);
  };

  // 处理标签页点击
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  // 渲染店铺集管内容
  const renderStoreManageContent = () => (
    <>
      {/* 顶部说明文字 */}
      <div className="description-section">
        <p className="description-text">
          在不改变店铺所有权的前提下，GEP的A用户（发起方）可以把授权绑定的店铺集管至GEP的B用户（简称"接收方"），集管成功后，这些店铺收款资金会自动归集至接收方，便于店铺资金集中管理。
        </p>
        <button
          type="button"
          className="link-text"
          onClick={handleUnauthorized}
        >
          查看集管操作流程
        </button>
      </div>

      {/* 温馨提示 */}
      <div className="tips-section">
        <div className="tips-title">温馨提示：</div>
        <div className="tips-content">
          <p>1. 集中管理店铺的收款账户入账会实时转入接收方账户。</p>
          <p>2. 发起集中管理需要发起方和接收方均完成实名认证。</p>
          <p>
            3.
            发起店铺集中管理时的店铺余额（包含在途资金）将归集于接受方账户，请谨慎操作
          </p>
          <p>4. 发起方的店铺收款资金不会同步至接收方。</p>
          <p>5. 如果发起方的结算状态签署，无法发起集中管理和资金归集。</p>
          <p>6. 接收方主体类型只支持大陆个人、大陆企业和香港企业。</p>
          <p>
            7. 集中管理店铺入账明细，可点击集管记录-集管入账记录中实时查看。
          </p>
        </div>
      </div>

      {/* 两个卡片 */}
      <div className="cards-container">
        {/* 左侧卡片：店铺集中管理 */}
        <div className="card">
          <div className="cart_text">
            <div className="card-icon">
              <img alt="" src="/account/m1-1.png" />
            </div>
            <h3 className="card-title">店铺集中管理</h3>
            <p className="card-description">
              用户可以手动选择需集中管理的店铺，对于新增店铺，仍需手动发起集中管理
            </p>
          </div>
          <div className="cart_botton">
            <button className="btn-primary" onClick={handleUnauthorized}>
              发起管理
            </button>
          </div>
        </div>

        {/* 右侧卡片：集管记录 */}
        <div className="card">
          <div className="cart_text">
            <div className="card-icon">
              <img alt="" src="/account/m1-2.png" />
            </div>
            <h3 className="card-title">集管记录</h3>
            <p className="card-description">查看店铺集管的发起和接收记录</p>
          </div>
          <div className="cart_botton">
            <button className="btn-secondary" onClick={handleUnauthorized}>
              查看记录
            </button>
          </div>
        </div>
      </div>
    </>
  );

  // 渲染店铺迁移内容
  const renderStoreMigrationContent = () => (
    <>
      {/* 顶部说明文字 */}
      <div className="description-section">
        <p className="description-text">
          在不改变电商平台收款账户的前提下，将GEP
          A用户（迁出方）下的店铺迁移至GEP
          B用户（迁入方）下，迁移成功后，款项会入账至GEP B用户对应的收款账户。
        </p>
        <button
          type="button"
          className="link-text"
          onClick={handleUnauthorized}
        >
          查看店铺迁移手册
        </button>
      </div>

      {/* 温馨提示 */}
      <div className="tips-section">
        <div className="tips-title">温馨提示：</div>
        <div className="tips-content">
          <p>1. 发起店铺迁移申请后，需迁入方在其商户端进行同意或拒绝操作。</p>
          <p>2. 店铺迁移成功后，后续资金将入账至迁入方收款账户。</p>
          <p>3. 店铺迁移前的交易明细、资金明细不迁移至迁入方。</p>
          <p>4. 迁出方的店铺收款资金不同步至迁入方。</p>
        </div>
      </div>

      {/* 两个卡片 */}
      <div className="cards-container">
        {/* 左侧卡片：迁移店铺 */}
        <div className="card">
          <div className="cart_text">
            <div className="card-icon">
              <img alt="" src="/account/m1-1.png" />
            </div>
            <h3 className="card-title">迁移店铺</h3>
            <p className="card-description">
              用户可以手动选择需迁移的店铺，按钮置灰的为不可迁移店铺，用户可以根据不可迁移原因进行处理
            </p>
          </div>
          <div className="cart_botton">
            <button className="btn-primary" onClick={handleUnauthorized}>
              发起迁移
            </button>
          </div>
        </div>

        {/* 右侧卡片：迁移记录 */}
        <div className="card">
          <div className="cart_text">
            <div className="card-icon">
              <img alt="" src="/account/m1-2.png" />
            </div>
            <h3 className="card-title">迁移记录</h3>
            <p className="card-description">查看店铺迁移的发起和接收记录</p>
          </div>
          <div className="cart_botton">
            <button className="btn-secondary" onClick={handleUnauthorized}>
              查看记录
            </button>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <Layout>
      <div className="store-manage">
        {/* 标签页 */}
        <div className="tabs-container">
          <div
            className={`tab-item ${activeTab === "店铺集管" ? "active" : ""}`}
            onClick={() => handleTabClick("店铺集管")}
          >
            店铺集管
          </div>
          <div
            className={`tab-item ${activeTab === "店铺迁移" ? "active" : ""}`}
            onClick={() => handleTabClick("店铺迁移")}
          >
            店铺迁移
          </div>
        </div>

        {/* 主要内容区域 */}
        <div className="content-container">
          {activeTab === "店铺集管"
            ? renderStoreManageContent()
            : renderStoreMigrationContent()}

          {/* 页脚 */}
        </div>

        {/* 未授权访问模态框 */}
        {showModal && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-icon">🔒</div>
              <h2 className="modal-title">未授权访问</h2>
              <p className="modal-message">您当前没有权限访问此功能</p>
            </div>
          </div>
        )}
      </div>
      <div className="page-footer">
        <p>© 2022 GLOBAL E-PAYMENT LIMITED. All Rights Reserved.</p>
      </div>
    </Layout>
  );
};

export default StoreManage;
